import SwiperCard from "../../components/swiperCard/SwiperCard";
import styles from "./recentBlogPage.module.scss";
import { useRef, useState, useEffect } from "react";

export default function RecentBlogPage() {
  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (MyRef.current) observer.observe(MyRef.current);

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);
  return (
    <div className={styles.container} ref={MyRef}>
      <div className={styles.wrapper}>
        <div className={visible ? styles.topTitle : styles.topTitleAction}>
          <div className={styles.title}>RECENT BLOG</div>
        </div>

        <div className={styles.middile}>
          <div className={styles.middileWrapper}>
            <div className={visible ? styles.middileLeft : styles.middleLeftAction}>
              <SwiperCard/>
            </div>
            <div className={styles.middleRight }>
              <div className={visible ? styles.heading : styles.headingEvent}>
                <h1>Financial Tips and News on Our Official Blog</h1>
              </div>
              <div className={visible ? styles.content : styles.contentEvent}>
                  Creating and sticking to a budget is essential for achieving
                  financial stability and reaching your financial goals. Whether
                  you're saving for a big purchase, paying off debt, or just
                  trying to manage your day-to-day expenses, a well-planned
                  budget can make all the difference. In this blog post, we'll
                  walk you through top tips for effective financial planning and
                  how you can use megam to streamline the process.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
